import script from "./UploadFilesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFilesDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UploadFilesDialog.vue?vue&type=style&index=0&id=40f61cb0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f61cb0"]])

export default __exports__